// app/javascript/src/components/imports_polling.js

class ImportsPolling {
  constructor(campaignId) {
    this.campaignId = campaignId;
    this.pollingInterval = null;
    this.pollingDuration = 600000; // 10 minutos
    this.pollingFrequency = 3000;   // 3 segundos
  }

  start() {
    const processingRows = document.querySelectorAll('[data-import-status="processing"]');

    if (processingRows.length === 0) {
      console.log('Nenhuma importação em processamento.');
      return;
    }

    console.log(`Iniciando polling para ${processingRows.length} importação(ões)...`);
    this.checkAllProcessing();
    this.pollingInterval = setInterval(() => this.checkAllProcessing(), this.pollingFrequency);
    setTimeout(() => this.stop(), this.pollingDuration);
  }

  stop() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
      console.log('Polling encerrado.');
    }
  }

  checkAllProcessing() {
    const processingRows = document.querySelectorAll('[data-import-status="processing"]');

    if (processingRows.length === 0) {
      this.stop();
      return;
    }

    console.log(`Verificando ${processingRows.length} import(s)...`);

    processingRows.forEach(row => {
      const importId = row.dataset.importId;
      this.updateImportRow(importId);
    });
  }

  updateImportRow(importId) {
    fetch(`/campanhas/${this.campaignId}/importacoes/${importId}/row`, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'text/html'
      }
    })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.text();
      })
      .then(html => {
        const row = document.getElementById(`import_${importId}`);
        if (!row) {
          console.warn(`Row import_${importId} não encontrada`);
          return;
        }

        const oldStatus = row.dataset.importStatus;

        const tempTable = document.createElement('table');
        const tempTbody = document.createElement('tbody');
        tempTable.appendChild(tempTbody);
        tempTbody.innerHTML = html.trim();

        const newRow = tempTbody.querySelector('tr');

        if (!newRow) {
          console.error(`HTML retornado não contém <tr>:`, html);
          return;
        }

        const newStatus = newRow.dataset.importStatus;

        if (!newStatus) {
          console.error(`Nova row não tem data-import-status:`, newRow);
          return;
        }

        row.outerHTML = html.trim();

        // Reinicializa Feather Icons
        if (typeof feather !== 'undefined') {
          feather.replace();
        }

        console.log(`Import ${importId}: ${oldStatus} → ${newStatus}`);

        if (oldStatus === 'processing' && newStatus !== 'processing') {
          console.log(`✓ Import ${importId} finalizado`);
        }
      })
      .catch(error => console.error(`Erro ao atualizar import ${importId}:`, error));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const importsTable = document.getElementById('imports-table-body');

  if (importsTable) {
    const campaignId = importsTable.dataset.campaignId;

    if (campaignId) {
      const polling = new ImportsPolling(campaignId);
      polling.start();
    }
  }
});

export default ImportsPolling;